export default __webpack_public_path__ + "assets/logoWithoutBrand.41b2f732.svg";